// utils/enrichImageData.js
import {normalizeString} from "./normalizeString"
/**
 * Enrichit une image avec toutes les données calculées nécessaires à l'affichage
 * Cette fonction est appelée UNE SEULE FOIS au chargement des données
 *
 * @param {Object} img - Image brute depuis le CSV
 * @param {Object} colorMap - Mapping des couleurs par typologie
 * @returns {Object} Image enrichie avec toutes les données calculées
 */

const chronologyPeriods = new Set();

export const enrichImageData = (img, colorMap) => {
  // 🔹 Extraction des valeurs avec fallbacks
  const pA = img?.adressA ?? "";
  const pB = img?.adressB ?? "";
  const num = img?.num ?? "";
  // 🔹 Construction de l'adresse complète
  // enlève virgule si num vide
  // remplace les apostrophes suivies d'un espace, par un apostrophe
  // inclure ce type d'apostrophe -> ’
  const adress = `${num}, ${pA} ${pB}`
    .trim()
    .replace(/^,\s*/, "")
    .replace(/' /g, "'")
    .replace(/’ /g, "’");

  const typoloA = img?.typoloA ?? "";
  //const typoloAbis = img?.typoloA ?? "";
  const typoloAbis = typoloA.includes("_") ? typoloA.split("_")[0] : typoloA;

  const mainTag = typoloA?.split("_")[0] || "";

  const bgColor = img?.color ?? "#f3f3f3";
  // 🔹 Calcul de la couleur typologique
  const typoloColor = colorMap[mainTag] || "#888";

  const typoloB = img?.typoloB ?? "";

  const typoloColorB =
    typoloB !== "" ? colorMap[typoloB.split("_")[0]] : typoloColor;

  // 🔹 Validation et formatage des coordonnées
  const hasCoords =
    img.lat != null &&
    img.lat !== undefined &&
    img.lon != null &&
    img.lon !== undefined &&
    !isNaN(img.lat) &&
    !isNaN(img.lon);

  const coords = hasCoords ? { lat: img.lat, lng: img.lon } : null;
  //if( !hasCoords ) console.log("hasCoords",hasCoords,"coords",coords);
  // 🔹 Construction de l'URL Street View
  const streetViewUrl = hasCoords
    ? `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${img.lat},${img.lon}`
    : "";

  // nettoyage date
  if (img.date) {
    const str = img.date.split(",").slice(0, 2).join(",");
    img.date = str;
  }

  const normalizedNote = img.note ? normalizeString(img.note) : "";

  const { note, dateOld, idLR, nymeBK, lat, lon, ...cleanImg } = img;

  const sortDate = normalizeDate(img.date);

if (sortDate?.type === "range") {
  chronologyPeriods.add(`${sortDate.start}-${sortDate.end}`);
}

  // 🔹 Retour de l'image enrichie (spread de l'original + nouvelles props)
  return {
    ...cleanImg, //...img,
    // Données calculées ajoutées
    typoloAbis,
    bgColor,
    adress, // ✅ Adresse formatée
    typoloColor, // ✅ Couleur calculée
    typoloColorB, // ✅ Couleur calculée
    coords, // ✅ Objet {lat, lng} ou null
    streetViewUrl, // ✅ URL Google Maps
    hasCoords, // ✅ Booléen de validation
    mainTag, // ✅ Tag principal (peut être utile ailleurs)
    sortDate,
    normalizedNote,
  };
};

/**
 * Enrichit un tableau d'images
 * @param {Array} images - Tableau d'images brutes
 * @param {Object} colorMap - Mapping des couleurs
 * @returns {Array} Tableau d'images enrichies
 */
export const enrichImagesData = (images, colorMap) => {
  if (!Array.isArray(images)) return [];
  return images.map((img) => enrichImageData(img, colorMap));
};

function normalizeDate(raw) {
  if (!raw) return null;

  // supprimer éventuel 3e élément
  const parts = raw.split(",").map(p => p.trim()).slice(0, 2);

  // let century = parts[0]; // pas utilisé
  let value = parts[1] || null;

  // cas sans valeur exploitable
  if (!value) return null;

  // cas spéciaux
  if (/circa\s*1900/i.test(value)) {
    return { type: "range", start: 1890, end: 1910 };
  }

  if (/contemporain/i.test(value)) {
    return { type: "range", start: 1980, end: 2025 };
  }

  // période "1920-30"
  if (/^\d{3,4}\s*-\s*\d{1,4}$/.test(value)) {
    const [startStr, endStr] = value.split("-");
    const start = parseInt(startStr.trim(), 10);

    // compléter style 1920-30 → 1930
    const end = endStr.trim().length === 2
      ? parseInt(startStr.slice(0, 2) + endStr.trim(), 10)
      : parseInt(endStr.trim(), 10);

    return { type: "range", start, end };
  }

  // simple année
  if (/^\d{3,4}$/.test(value)) {
    const year = parseInt(value, 10);
    return { type: "point", year };
  }

  return null;
}

// devenu inutile
export function getChronologyPeriods() {
      
  return ["1700-1889","1890-1919","1920-1939","1940-1989","1990-2025"];
 
/*
  return Array.from(chronologyPeriods)
    .sort((a,b) => parseInt(a.split("-")[0]) - parseInt(b.split("-")[0]));
    */
}
